import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppState } from '../core';

import { TableViewComponentBase, TableViewQueryRequest, TableViewQueryResponse }
  from '../shared/components/table-view/table-view-component-base';
import { EventLogRecord } from '../core/models/event-log-record';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../environments/environment';
import { firstValueFrom } from 'rxjs';

//
// For admin users to see mobile and testbed client activity
//
@Component({
  selector: 'app-event-log-table',
  templateUrl: '../shared/components/table-view/table-view.component.html',
  styleUrls: [
    '../shared/components/table-view/scss/table-view.scss',
    '../shared/components/table-view/scss/app-tab-full-height.scss',
    '../shared/components/table-view/scss/fixed-headers-and-column.scss',
    './event-log-table.component.scss'
  ]
})
export class EventLogTableComponent extends TableViewComponentBase<EventLogRecord> implements OnInit, OnDestroy {

  constructor(
    public bsModalService: BsModalService,
    appState: AppState,
    elementRef: ElementRef,
    datePipe: DatePipe,
    public httpClient: HttpClient
  ) {
    super(appState, bsModalService, elementRef, datePipe)
    this.tableColumns = [
      { title: 'Time', name: 'occuredAt', visible: true, template: 'fulllocaltime' },
      { title: 'ID', name: 'id', visible: false },
      { title: 'Level', name: 'level', visible: true },
      { title: 'Type', name: 'title', visible: true },
      { title: 'Message', name: 'message', visible: true },
      { title: 'User Type', name: 'userType', visible: true },
      { title: 'User ID', name: 'userId', visible: true },
      { title: 'Data', name: 'data', visible: false },
    ];
    this.sortColumns = [
      { key: 'occuredAt', order: 'DESC' },
    ];
  }

  ngOnInit(): void {
    this.init()
  }


  ngOnDestroy(): void {
    this.destroy()
  }


  doQuery = async (queryReq: TableViewQueryRequest) => {
    try {
      const result: any = await firstValueFrom(this.httpClient.get(
        `${AppConfig.apiUrl}/eventLog/find`,
        { params: { criteria: JSON.stringify(queryReq) } }))
      const resp: TableViewQueryResponse<EventLogRecord> = result.data
      return resp
    } catch (error) {
      console.error('EventLogTableComponent.doQuery() error: ' + error?.message)
      throw error
    }
  }


}
